import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { MenuItems } from '../enums/MenuItems'
import LayoutSingleViewFullWidth from '../uiV2/common/layout/LayoutSingleViewFullWidth'
import Tabs from '../components/Tabs'
import TenantsTab from '@/components/users/TenantsTab'
import JobSeekersTab from '@/components/users/JobSeekersTab'
import ReferralsTab from '@/components/users/ReferralsTab'
import UsersTab from '@/components/users/UsersTab'
import LoginAuditTab from '@/components/users/LoginAuditTab'

const USER_TAB_LABELS = [
    'Tenants',
    'Users',
    'Job Seekers',
    'Referrals',
    'Login Audit',
] as const

const slugify = (label: string) =>
    label
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')

function Users(): React.JSX.Element {
    const [searchParams, setSearchParams] = useSearchParams()
    const tabParam = searchParams.get('tab') || ''

    const slugToIndex = useMemo(() => {
        const map = new Map<string, number>()
        USER_TAB_LABELS.forEach((label, index) =>
            map.set(slugify(label), index),
        )
        return map
    }, [])

    const indexToSlug = useMemo(
        () => USER_TAB_LABELS.map((label) => slugify(label)),
        [],
    )

    const activeIndex = useMemo(() => {
        const idx = slugToIndex.get(tabParam)
        return idx !== undefined ? idx : 0
    }, [slugToIndex, tabParam])

    return (
        <LayoutSingleViewFullWidth activeMenuItem={MenuItems.Users}>
            <Tabs
                activeIndex={activeIndex}
                onTabChange={(idx) => {
                    const nextSlug = indexToSlug[idx] || indexToSlug[0]
                    const newParams = new URLSearchParams(searchParams)
                    newParams.set('tab', nextSlug)
                    setSearchParams(newParams, { replace: true })
                }}
                tabs={[
                    {
                        label: USER_TAB_LABELS[0],
                        content: <TenantsTab />,
                    },
                    {
                        label: USER_TAB_LABELS[1],
                        content: <UsersTab isActive={activeIndex === 1} />,
                    },
                    {
                        label: USER_TAB_LABELS[2],
                        content: <JobSeekersTab isActive={activeIndex === 2} />,
                    },
                    {
                        label: USER_TAB_LABELS[3],
                        content: <ReferralsTab isActive={activeIndex === 3} />,
                    },
                    {
                        label: USER_TAB_LABELS[4],
                        content: <LoginAuditTab isActive={activeIndex === 4} />,
                    },
                ]}
            />
        </LayoutSingleViewFullWidth>
    )
}

export default Users
